import { Box, BoxProps } from 'material-hu';
import huLogo from 'src/assets/hu.svg';

const DIMENSION = 52;

const Logo = (props:BoxProps<'img'>) => (
  <Box
    component="img"
    alt="logo"
    src={huLogo}
    sx={{ height: DIMENSION, width: DIMENSION }}
    {...props}
  />
);

export default Logo;
